import axios from 'axios';
import {vk2AppIdMap} from "@/enum/const";
export default {
    methods: {
        getGrantingPermissions(state){
            console.log(state)
            return new Promise((resolve, reject) => {
                const urlParams = this.getParams()

                const params = new URLSearchParams();
                params.append('grant_type', 'authorization_code');
                params.append('redirect_uri', 'https://store-funplusid.funplus.com');
                // params.append('redirect_uri', location.origin);
                params.append('code', urlParams.code);
                params.append('client_id', vk2AppIdMap[state.game]);
                params.append('device_id', urlParams.device_id);
                params.append('state', urlParams.state);
                params.append('code_verifier', `${state.clienttoken}_funplus`);

                axios.post('https://id.vk.com/oauth2/auth', params, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                })
                    .then(res => {
                        // res = { 
                        //     "refresh_token": "vk2.a.57uPsUvsfKFsxfhhi8b03C92ptayFxSRqClz1nrHYaTduKHBSSgw6kY9bHuywjiW-nS5yUScM3DyuVfR5LF5Ldso2i4I9oBxJ60Wio5CHiLKMmDXVlXDZVIe1wATUuxQRj8veXYnVzrWr44qslbOUScoK1aQMMm9Hv9f_ii6JY8hwbpARou2nD4_oVa5LsKR8TrMD772qc5VTO0DfML_daU-Ud2a1hneYYWvXERSl4iKSfzrX9BuFVZpzd0XGjLt",
                        //     "access_token": "vk2.a.kFUpgh9lOW5ZRNWJbxfcjdRY5eqyXjCQjXjzlnYlBxVLiGsL6JCtp60Tuo1_vPDLHxnbRrq0efADaLijgdQvFGIhmU1XFz5RJYBYg2IH2a5KsLkLdl1v4UjvXNcTar0VBNtpMEYex0Vx8W4hogcluBKhKWC2QcRG4nZfzE9j4in8hBskc3YKaBj_9o-_ny_gTYzjOE24QsvV7NcbvxQ5dtSoN023-xi94hrjsXc0FDU6UaITwCG9zsyyDfH3RXu5",
                        //     "id_token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpaXMiOiJWSyIsInN1YiI6NDc5Nzk5ODA0LCJhcHAiOjU0MDk2NDcxLCJleHAiOjE3OTMwMDc4MjMsImlhdCI6MTc2MTkwMzgyMywianRpIjoyMX0.JYe0Eqjtp1bA3Iw8pILELXvxtmFCVdwvlyHybu6IRegsS7rgyVJBPEBFKmf8vJMsfvdSP-k8lb6c8MvmnuZdnHKfR717pD6rVcKY_eM14QdPYZDOEH8PKLNq9zJln89LX5YT_x4gcmck6zCmX9ZTFuAgeuayUkjti58XPPTwdm4hw2r7BgtlB-EUwTt28j7PaVgMsbWroy1oDzUlSPI2higAiLsqzRIKgysHkpU6nLsBnkRIWHIg-hj-jC2ZQNYqeMQIg83j2eWHt-OsB1gkEJ5MpSadejuqQ7BrDl8j_XJdG4tYH7WaGI1QMQtsSro3zTNMNSUda5SsM-PstxXbXsIqmI4C34ZyYFTwdv50zB71YxCH48W9O6e8uuJBblnszSCWC4zhOD-Jwo7oiWNM1YBmT-X83ppqAT8yrkZBM-4EE4ydKWeOQt4j7JPlqViQg7ln8_g4huKl3aKqbqpcWeulSTn9i5FBFM00ZbhE6XZjFusehId4vSqux356lfkGsmQ3_vNM_MY1ibFAIgySqkeKW3ifLIOoOXEakVeptOAYp5Dv2kBprM3Q4an_COkeavSIOVUtTQk9X8yDaL4UBUH5ALZL4uCB_tuA_jEcTVaHrWRDAT6I30p0Zc-hcKCsux0aGZNySAq4lteisYRO3cAcXBSisWK_OwkPXwVjmh0",
                        //     "token_type": "Bearer",
                        //     "expires_in": 3600,
                        //     "user_id": 479799804,
                        //     "state": "JTdCJTIyZ2FtZSUyMiUzQSUyMjg2MTIlMjIlMkMlMjJwb3J0JTIyJTNBNDk3MzQlMkMlMjJzb2NpYWx0eXBlJTIyJTNBJTIydmslMjIlMkMlMjJjbGllbnR0b2tlbiUyMiUzQSUyMjg0N2U0N2M2YTFiNjQ5MDViN2FjMTliZDE1Y2U3MWMyJTIyJTJDJTIybGFuZyUyMiUzQSUyMnpoX2NuJTIyJTdE",
                        //     "scope": "vkid.personal_info offline"
                        // }
                        if (res.status === 200) resolve(res.data)
                        else resolve({access_token: ''})
                    })
                    .catch(() => resolve({access_token: ''}))
            })
        }
    }
}
